module.exports = __webpack_public_path__ + "static/media/YF83_9.82e08b8a.jpg";